// extracted by mini-css-extract-plugin
export default {"main":"style_main__ekx9O","parent":"style_parent__IvYRw","routesBox":"style_routesBox__AEk81","routesParent":"style_routesParent__ho0wI"};